import type { AudioFormat } from '../../api/cc-smarts/getAudio';
import type { ContentDetails } from '../../types/activeContent';
import { audioPlayerState } from '../state/AudioPlayerState';

export function getRequestParamsForAudioPlayer({
	activationId,
	product,
	cloudId,
	locale,
	format,
	supportingContent,
}: {
	activationId: string;
	product: string;
	cloudId: string;
	locale: string;
	format: AudioFormat;
	supportingContent: ContentDetails[];
}) {
	const {
		activeContent: { contentId, contentType },
		activeFeature,
		customization,
	} = audioPlayerState.get();

	const overrideSupportingContent =
		supportingContent.length > 0 ? supportingContent.map((resource) => resource.ari) : undefined;

	return {
		activationId,
		product,
		cloudId,
		locale,
		contentId,
		contentType,
		type: activeFeature,
		format,
		instructions: customization,
		supportingResourceARIs:
			overrideSupportingContent || supportingContent.map((resource) => resource.ari),
	};
}
